import { Injectable } from '@angular/core';

// Services
import { RouteParam, ServiceBase } from '../service-base';

const CLASS_NAME = 'ProductSectionTitle';
const ENDPOINT = `/product-section-titles/`;

const ROUTES: RouteParam[] = [
    { key: 'massDelete', path: 'mass-delete/' },
]

/**
 * Titres de sections et de sous-sections réutilisables dans les documents de vente (#1186).
 * Contrat : `b4cash-srv/documentation/products/PRODUCT_SECTION_TITLES_FRONT.md`.
 */
@Injectable({
    providedIn: 'root'
})
export class ProductSectionTitleService extends ServiceBase {
    constructor() {
        super(CLASS_NAME, ENDPOINT);
        this.addRoutes(ROUTES);
    }
}
